import axios from "axios";
import handleError from "./handleerror";

const SERVER_DOMAIN = process.env.REACT_APP_API_URL;

const getHeaders = () => {
  return {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
};

export const get = (path) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${SERVER_DOMAIN}${path}`, getHeaders())
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};

// HTTP POST Request - Returns Resolved or Rejected Promise
export const post = (path, data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${SERVER_DOMAIN}${path}`, data, getHeaders())
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};
